import React from 'react';
import classNames from 'classnames';
import { Dropdown } from '@hallmark/web.core.forms.dropdown';
import { FontStyleProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const FontStyle = ({
  addClass = '',
  label,
  fonts,
  onChange,
  selectedFont,
  testId = 'font-style',
}: FontStyleProps): React.ReactElement => {
  const classes = classNames(styles['font-style'], addClass);

  const selectOptions = fonts.map((font) => ({ id: font.id, value: font.text, label: font.text, font: font.family }));

  return (
    <Dropdown
      addClass={classes}
      label={label}
      options={selectOptions}
      onChange={onChange}
      value={selectedFont}
      testId={testId}
      isCustomSelect
    />
  );
};
